import { WEBINAR_DURATION } from "./shared";

const ITEMS = [
  WEBINAR_DURATION,
  "5 CORE MODULES",
  "LIVE Q&A INCLUDED",
  "FLORIDA & PENNSYLVANIA",
  "NO COST TO ATTEND",
  "VA-BACKED PURCHASE STRUCTURING",
];

export default function Ticker({ items = ITEMS }) {
  const row = (key) => (
    <div key={key} className="flex items-center shrink-0">
      {items.map((item, i) => (
        <span key={i} className="flex items-center font-mono-strict text-[11px] tracking-[0.25em] text-white/40 whitespace-nowrap">
          <span className="px-8">{item}</span>
          <span className="text-[#0162CA]">◆</span>
        </span>
      ))}
    </div>
  );
  return (
    <section className="border-y border-white/10 py-4 overflow-hidden bg-[#001736]" data-testid="proof-ticker">
      <div className="marquee-track">{[0, 1].map(row)}</div>
    </section>
  );
}
